import type { ThemeDefinition } from './types';

export const koodookaLight: ThemeDefinition = {
  id: 'koodooka',
  name: 'Koodooka',
  description: 'Koodooka brand light theme — bone surfaces, ink typography, and brick accents',
  mode: 'light',
  tokens: {
    colorPrimary: '#9E321F',
    colorPrimaryOnSidebar: '#CA5A43',
    colorPrimaryHover: '#B23E28',
    colorPrimaryActive: '#7F2719',
    colorPrimaryBg: '#F7E9E5',
    colorFocus: '#B23E28',
    colorSecondary: '#665B55',
    colorAccent: '#B23E28',
    colorSuccess: '#16805A',
    colorWarning: '#B7791F',
    colorError: '#C53030',
    colorInfo: '#2563EB',
    colorBgBase: '#F4F0EA',
    colorBgContainer: '#FAF8F5',
    colorBgElevated: '#FFFFFF',
    colorBgSidebar: '#0B0B0C',
    colorText: '#0B0B0C',
    colorTextSecondary: '#665B55',
    colorTextTertiary: '#8F827A',
    colorTextOnChrome: '#FAF8F5',
    colorTextInverse: '#FAF8F5',
    colorBorder: '#E3D7D0',
    colorBorderSecondary: '#F0E8E1',
    boxShadow: '0 1px 3px rgba(11, 11, 12, 0.08), 0 4px 12px rgba(158, 50, 31, 0.08)',
    boxShadowSecondary: '0 4px 16px rgba(11, 11, 12, 0.10), 0 8px 24px rgba(158, 50, 31, 0.08)',
    glassBlur: '16px',
    glassOpacity: '0.42',
    glassContentOpacity: '0.78',
    glassModalOpacity: '0.62',
    glassSaturation: '140%',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontFamilyHeading: '"Instrument Serif", Georgia, serif',
    fontFamilyDisplay: '"Instrument Serif", Georgia, serif',
    fontFamilyMono: '"SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Menlo, Consolas, monospace',
    fontSize: 14,
    fontSizeHeading: 20,
    borderRadius: 8,
    borderRadiusLG: 16,
    cardBorder: '#E3D7D0',
    cardShadow: '0 1px 3px rgba(11, 11, 12, 0.08)',
  },
};

export const koodooka = koodookaLight;
